import noScroll from "@/utils/noScroll.js";

export default function (element) {
    let isOpen = false;

    window.addEventListener("openMainMenu", function () {
        showMenu();
    });

    window.addEventListener("closeMainMenu", function () {
        hideMenu();
    });

    window.addEventListener("toggleMainMenu", function () {
        if (isOpen) {
            window.dispatchEvent(new CustomEvent('closeMainMenu'));
        } else {
            window.dispatchEvent(new CustomEvent('openMainMenu'));
        }
    });

    function showMenu() {
        isOpen = true;

        element.classList.add("open");
        noScroll.hideScroll();
    }

    function hideMenu() {
        isOpen = false;

        element.classList.remove("open");
        noScroll.showScroll();
    }
};

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary